<app-shared-banner *ngIf="showBanner$ | async" #sharedTopBanner [svgIcon]="banner.svgIcon" [icon]="banner.icon"
  [attr.aria-label]="banner.ariaLabel" [attr.data-type]="banner.type" [attr.data-icon-color]="banner.iconColor"
  [bannerContainerClass]="banner?.bannerContainerClass">
  <span banner-header [innerHTML]="banner.message.replace('\n', '<br/>')"></span>

  <div banner-buttons fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center"
        *ngIf="banner.primaryButton || banner.secondaryButton"
        fxLayoutGap="8px" fxLayoutGap.xs="16px" fxFlexOffset="8px">
  <button mat-button mat-raised-button class="banner-button"
          (click)="banner.secondaryButton?.action(sharedTopBanner)"
          [trackClick]="banner.trackingInfo"
          [disabled]="isButtonDisabled(banner.secondaryButton)"
          *ngIf="banner.secondaryButton">
    <span class="banner-button__label">{{ banner.secondaryButton.text | translate }}</span>
  </button>
  <button mat-button mat-stroked-button class="banner-button banner-button--primary"
          (click)="banner.primaryButton?.action(sharedTopBanner)"
          [trackClick]="banner.trackingInfo"
          [disabled]="isButtonDisabled(banner.primaryButton)"
          *ngIf="banner.primaryButton">
    <span class="banner-button__label">
      {{ banner.primaryButton.text | translate }}
    </span>
  </button>
</div>
</app-shared-banner>
